module.exports = __webpack_public_path__ + "img/refer-friend.a827b706.png";